import { z } from 'zod'

export const PartnerTagSchema = z.union([
  z.literal('aer_lingus'),
  z.literal('british_airways'),
  z.literal('vueling'),
  z.literal('avios'),
])
export type PartnerTag = z.infer<typeof PartnerTagSchema>
